import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [state, setState] = useState({ busy: false, error: '', done: false });

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setState({ ...state, error: 'Passwords do not match' });
    setState({ busy: true, error: '', done: false });
    try {
      await api.post('/api/auth/password-reset/confirm', { token: params.get('token'), password: pw });
      setState({ busy: false, error: '', done: true });
    } catch (err) {
      const d = err.response?.data?.detail;
      setState({ busy: false, error: typeof d === 'string' ? d : 'Password does not meet the requirements', done: false });
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <form onSubmit={submit} className="w-full max-w-sm space-y-6" data-testid="reset-password-form">
        <h1 className="text-4xl font-headings font-bold">Choose a new password</h1>
        {state.done ? (
          <p className="text-sm rounded-lg border border-border bg-card p-4" data-testid="reset-password-done">Password updated. All other sessions were signed out. <Link to="/login" className="underline">Sign in</Link></p>
        ) : (
          <>
            <div className="space-y-2">
              <Label htmlFor="rp-1">New password (12+ characters)</Label>
              <Input id="rp-1" type="password" required minLength={12} value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password-input" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="rp-2">Confirm password</Label>
              <Input id="rp-2" type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-password-confirm-input" />
            </div>
            {state.error && <p className="text-sm text-destructive" data-testid="reset-password-error">{state.error}</p>}
            <Button type="submit" className="w-full" disabled={state.busy} data-testid="reset-password-submit">Update password</Button>
          </>
        )}
      </form>
    </div>
  );
}
